import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Camera, ChevronRight } from 'lucide-react';

export const CleaningPhotosPanel = () => {
  const navigate = useNavigate();
  const [notifs, setNotifs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/notifications')
      .then(res => setNotifs((res.data || []).filter(n => n.type === 'cleaning_photos' && !n.read)))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading || notifs.length === 0) return null;

  return (
    <Card className="border-purple-500/40" data-testid="cleaning-photos-panel">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-3">
        <div>
          <CardTitle className="flex items-center gap-2 text-lg">
            <Camera className="w-5 h-5 text-purple-500" />
            Foto's na reiniging
            <Badge className="bg-purple-500 text-white">{notifs.length} te verwerken</Badge>
          </CardTitle>
          <CardDescription>Toegevoegd door install/clean — vink ze aan en voeg toe aan de klantmap</CardDescription>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-2 max-h-72 overflow-y-auto pr-1">
          {notifs.map((n) => (
            <div
              key={n.id}
              onClick={() => navigate(n.data?.customer_id ? `/customers/${n.data.customer_id}` : '/cleaning')}
              className="flex items-center justify-between gap-3 p-3 rounded-lg bg-purple-500/5 hover:bg-purple-500/10 transition-colors cursor-pointer"
              data-testid={`cleaning-photo-notif-${n.id}`}
            >
              <div className="min-w-0">
                <p className="font-medium truncate">{n.message}</p>
                <p className="text-xs text-muted-foreground">
                  {n.created_at ? new Date(n.created_at).toLocaleString('nl-BE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : ''}
                </p>
              </div>
              <ChevronRight className="w-4 h-4 text-muted-foreground shrink-0" />
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default CleaningPhotosPanel;
